/**
@format
@flow
*/
import React from 'react';
import Colors from '@ziynx/theme/colors';
import { TextLink as KrispyTextLink } from '@krispy/links/web';

type Props = $ReadOnly<{|
    /**
     * Text for the link.
     */
    children?: any,

    /**
     * Typography size choices
     */
    small?: boolean,
    medium?: boolean,
    large?: boolean,

    /**
     * Typography type
     */
    type?: 'body' | 'subheading' | 'heading',

    /**
     * URL for the link.
     */
    href?: string,

    /**
     * Custom color for TextLink
     */
    color?: string,

    /**
     * Function to be fire when link is clicked.
     */
    onClick?: (event?: SyntheticEvent<HTMLAnchorElement>) => any | Promise<any>,

    /**
     * Target for the link to open.
     */
    target?: string,
|}>;

const TextLink = (props: Props): React$Node => {
  const {
    children, href, onClick, small, medium, large, type, color, target, ...rest
  } = props;

  return (
    <KrispyTextLink
      href={href}
      onClick={onClick}
      color={color}
      small={small}
      medium={medium}
      large={large}
      type={type}
      target={target}
      {...rest}
    >
      {children}
    </KrispyTextLink>
  );
};

TextLink.defaultProps = {
  color: Colors.PrimaryBlue,
  type: 'subheading',
};

export default TextLink;
